import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import CandidateTab from './CandidateTab';
import NotificationPanels from './NotificationPanels';
import PersonalDetailsIcon from '../assets/img/personal-details-icon.png';
import '../assets/css/candidate-tab-form.css';
import BagIcon from '../assets/img/bag-icon.svg';
import CallIcon from '../assets/img/call-icon.png';
import EmailIcon from '../assets/img/email-icon.png';
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import { useDispatch, useSelector } from "react-redux";
import ProgressHeading from './Common/ProgressHeading.jsx';

const CandidateOtherDetails = ()=> {

  //Handling Form Reference
  const form = useRef();

  //Handling Initial States Floating Labels
  const [role,setRole]=useState();
  const [formData, setFormData] = useState({
    maritialStatus : null,
    highestEducation : null,
    email : null,
    homeMobile : null,
    disabled : null,
    emergencyContactName : null,
    emergencyContactRelation : null,
    emergencyContactEmail : null,
    emergencyContactMobile : null,
    emergencyContactHouseNo : null,
    emergencyContactColony : null,
    emergencyContactPinCode : null,
    emergencyContactCity : null,
    emergencyContactState : null,
    emergencyContactName2 : null,
    emergencyContactRelation2 : null,
    emergencyContactEmail2 : null,
    emergencyContactMobile2 : null,
    emergencyContactHouseNo2 : null,
    emergencyContactColony2 : null,
    emergencyContactPinCode2 : null,
    emergencyContactCity2 : null,
    emergencyContactState2 : null
  });


  //Handling Floating Labels
  const handleFloatingLabels = (e)=> {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

    return (
      <>

      <NotificationPanels/>
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header/>
      <Sidebar/> */}

      <section className="main-section candidate-tab-form" style={{paddingTop: '60px'}}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
             <ProgressHeading/>
              <CandidateTab activeTab={"Others Details"}/>
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form ref={form} className="p-3 form2 form-section">
              <StepCount activeTab={"Others Details"}/>
                <h2 className="fnt-smi-bld">Other Details</h2>
                <p className="text-muted">To obtain Credit information report from credit bureau kindly sure that enterd mobile.</p>
                <hr/>

                <h6 className="fnt-smi-bld mb-3">Candidate Information</h6>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="maritialStatus" id="maritialStatus" onChange={handleFloatingLabels} />
                        <label htmlFor="maritialStatus" className={formData.maritialStatus && 'focused'}>Martial Status</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={BagIcon}/>
                        <input type="text" className="form-control" name="highestEducation" id="highestEducation" onChange={handleFloatingLabels} />
                        <label htmlFor="highestEducation" className={formData.highestEducation && 'focused'}>Highest Education Level</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={EmailIcon}/>
                        <input type="text" className="form-control" name="email" id="email" onChange={handleFloatingLabels} />
                        <label htmlFor="email" className={formData.email && 'focused'}>Email Address</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CallIcon}/>
                        <input type="text" className="form-control" name="homeMobile" id="homeMobile" onChange={handleFloatingLabels} />
                        <label htmlFor="homeMobile" className={formData.homeMobile && 'focused'}>Home Phone Number</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">

                    <label className="d-block w-100">Disabled?</label>
                      
                      <div className="form-check form-check-inline mr-4">
                        <input type="radio" className="form-check-input" name="disabledYesNo" id="disabledYes" value="Yes" checked="true" />
                        <label htmlFor="disabledYes" className="form-check-label">Yes</label>
                      </div>

                      <div className="form-check form-check-inline">
                        <input type="radio" className="form-check-input" name="disabledYesNo" id="disabledNo" value="No" />
                        <label htmlFor="disabledNo" className="form-check-label">No</label>
                      </div>

                  </div>
                </div>

                <h6 className="fnt-smi-bld mb-3">Emergency Contact 1</h6>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactName" id="emergencyContactName" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactName" className={formData.emergencyContactName && 'focused'}>Name<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactRelation" id="emergencyContactRelation" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactRelation" className={formData.emergencyContactRelation && 'focused'}>Relationship<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={EmailIcon}/>
                        <input type="text" className="form-control" name="emergencyContactEmail" id="emergencyContactEmail" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactEmail" className={formData.emergencyContactEmail && 'focused'}>Email Address</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CallIcon}/>
                        <input type="text" className="form-control" name="emergencyContactMobile" id="emergencyContactMobile" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactMobile" className={formData.emergencyContactMobile && 'focused'}>Mobile Number</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactHouseNo" id="emergencyContactHouseNo" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactHouseNo" className={formData.emergencyContactHouseNo && 'focused'}>Flat /House no/Floor/Building<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactColony" id="emergencyContactColony" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactColony" className={formData.emergencyContactColony && 'focused'}>Colony/Street/Locality<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactPinCode" id="emergencyContactPinCode" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactPinCode" className={formData.emergencyContactPinCode && 'focused'}>Pin Code</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactCity" id="emergencyContactCity" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactCity" className={formData.emergencyContactCity && 'focused'}>City</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactState" id="emergencyContactState" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactState" className={formData.emergencyContactState && 'focused'}>State</label>
                      </div>
                    </div>
                  </div>
                </div>

                <h6 className="fnt-smi-bld mb-3">Emergency Contact 2</h6>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactName2" id="emergencyContactName2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactName2" className={formData.emergencyContactName2 && 'focused'}>Name<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactRelation2" id="emergencyContactRelation2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactRelation2" className={formData.emergencyContactRelation2 && 'focused'}>Relationship<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={EmailIcon}/>
                        <input type="text" className="form-control" name="emergencyContactEmail2" id="emergencyContactEmail2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactEmail2" className={formData.emergencyContactEmail2 && 'focused'}>Email Address</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label has-right-icon">
                        <img src={CallIcon}/>
                        <input type="text" className="form-control" name="emergencyContactMobile2" id="emergencyContactMobile2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactMobile2" className={formData.emergencyContactMobile2 && 'focused'}>Mobile Number</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactHouseNo2" id="emergencyContactHouseNo2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactHouseNo2" className={formData.emergencyContactHouseNo2 && 'focused'}>Flat /House no/Floor/Building<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactColony2" id="emergencyContactColony2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactColony2" className={formData.emergencyContactColony2 && 'focused'}>Colony/Street/Locality<sup className="text-danger">*</sup></label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactPinCode2" id="emergencyContactPinCode2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactPinCode2" className={formData.emergencyContactPinCode2 && 'focused'}>Pin Code</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactCity2" id="emergencyContactCity2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactCity2" className={formData.emergencyContactCity2 && 'focused'}>City</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input type="text" className="form-control" name="emergencyContactState2" id="emergencyContactState2" onChange={handleFloatingLabels} />
                        <label htmlFor="emergencyContactState2" className={formData.emergencyContactState2 && 'focused'}>State</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button>
                    <button className="btn btn-primary btn-lg btn-block mt-3">Save</button>
                  </div>
                </div>
              </form>

              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>

      </>
    );
}
export default CandidateOtherDetails;